import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const euro = (value) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format(Number(value || 0));

export default function AppAgenteOrdineDettaglioPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ordine, setOrdine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        const response = await authFetch(
          `/api/ordini/${encodeURIComponent(id)}/`
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.detail || "Impossibile caricare l'ordine.");
        }

        if (active) setOrdine(data);
      } catch (err) {
        if (active) setError(err.message || "Errore di caricamento.");
      } finally {
        if (active) setLoading(false);
      }
    }

    load();
    return () => { active = false; };
  }, [id]);

  const prodotti = Array.isArray(ordine?.items) ? ordine.items : [];

  return (
    <div className="container py-4" style={{ maxWidth: 960 }}>
      <button
        type="button"
        className="btn btn-outline-secondary mb-4"
        onClick={() => navigate("/app/agente/provvigioni")}
      >
        ← Torna alle provvigioni
      </button>

      <h2 className="fw-bold mb-3">Dettaglio ordine #{id}</h2>

      {loading && <p>Caricamento ordine...</p>}
      {error && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && ordine && (
        <>
          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h5 className="fw-bold">
                {ordine.cliente || ordine.per_nome || "Cliente aziendale"}
              </h5>
              <p className="mb-0">
                Stato: <strong>{ordine.status_it || ordine.status}</strong>
              </p>
            </div>
          </div>

          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Prodotti ordinati</h5>

              {prodotti.length === 0 && (
                <p className="text-muted">Nessun prodotto disponibile.</p>
              )}

              {prodotti.map((riga, index) => (
                <div
                  className="d-flex justify-content-between gap-3 border-bottom py-2"
                  key={riga.id || index}
                >
                  <div>
                    <strong>
                      {riga.product_name ||
                        riga.nome ||
                        riga.product?.name ||
                        "Prodotto"}
                    </strong>
                    <div className="small text-muted">
                      Quantità: {riga.quantity}
                    </div>
                  </div>
                  <strong>{euro(riga.line_subtotal)}</strong>
                </div>
              ))}

              <div className="d-flex justify-content-between mt-3">
                <span>Totale prodotti</span>
                <strong>{euro(ordine.subtotal)}</strong>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <span>Totale ordine</span>
                <strong>{euro(ordine.total)}</strong>
              </div>
            </div>
          </div>

          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h5 className="fw-bold">Fatturazione</h5>
              <p className="mb-0">
                {ordine.fatturazione?.ragione_sociale ||
                  ordine.fatturazione?.nome ||
                  "Dati non disponibili"}
              </p>
            </div>
          </div>

          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="fw-bold">Spedizione</h5>
              <p className="mb-0">
                {ordine.spedizione?.indirizzo ||
                  "Dati non disponibili"}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
